import "./BlackButton.scss";

const BlackButton = () => {
  return <div className="black-wrapper">FEATURED</div>;
};

export default BlackButton;
